if (!customElements.get('adev-comparison-table')) {
    customElements.define('adev-comparison-table', class adevComparisonTable extends HTMLElement {
        constructor() {
            super();
        }

        tableBackgroundSize(){
            const secondTds = this.querySelectorAll('[data-adev-comparison-table="background"]');

            let maxWidth = 0;

            secondTds.forEach(td => {
                const tdWidth = td.offsetWidth;
                if(tdWidth > maxWidth) {
                    maxWidth = tdWidth;
                }
            });

            this.style.setProperty('--table-background-size', `${maxWidth}px`);

            const firstColumnTds = this.querySelectorAll('[data-adev-comparison-table="first-column"]');

            let firstColumnMaxWidth = 0;

            firstColumnTds.forEach(td => {
                const tdWidth = td.offsetWidth;
                if(tdWidth > firstColumnMaxWidth) {
                    firstColumnMaxWidth = tdWidth;
                }
            });

            this.style.setProperty('--first-column-width', `${firstColumnMaxWidth}px`);
        }

        connectedCallback() {
            this.tableBackgroundSize();

            window.addEventListener('resize', this.tableBackgroundSize.bind(this));
            window.addEventListener('orientationchange', this.tableBackgroundSize.bind(this));
        }

        disconnectedCallback() {
            window.removeEventListener('resize', this.tableBackgroundSize.bind(this));
        }

    });
}